import { render, staticRenderFns } from "./details2.vue?vue&type=template&id=4a1247d2&scoped=true&"
import script from "./details2.vue?vue&type=script&lang=js&"
export * from "./details2.vue?vue&type=script&lang=js&"
import style0 from "./details2.vue?vue&type=style&index=0&id=4a1247d2&lang=scss&scoped=true&"
import style1 from "./details2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1247d2",
  null
  
)

export default component.exports